import { usePageKeyboard } from '../../../shared/keyboard/state/use-page-keyboard';

type UseCompareShortcutParams = {
    isEnabled: boolean;
    onCompare: () => void;
};

function isTypingInField(target: EventTarget | null): boolean {
    return (
        target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        (target instanceof HTMLElement && target.isContentEditable)
    );
}

export function useCompareShortcut({ isEnabled, onCompare }: UseCompareShortcutParams) {
    usePageKeyboard({
        onKeyDown: (event) => {
            let hasModifier = event.ctrlKey || event.metaKey || event.altKey;

            if (
                isEnabled &&
                event.key.toLowerCase() === 'n' &&
                !hasModifier &&
                !isTypingInField(event.target)
            ) {
                onCompare();
            }
        }
    });
}
